import { compose, hoistStatics, withProps } from 'recompose';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import User from './User';
import ProfileService from '../../../../../services/profile.service';
import ChannelsService from '../../../../../services/channels.service';
import UserService from '../../../../../services/user.service';

const mapStateToProps = state => ({
  logo: state.settings.subscriber.logo,
  token: state.auth.token,
  companyName: state.settings.subscriber.title,
});

const html2text = (str) => {
  if (str) {
    const tag = document.createElement('div');
    tag.innerHTML = str;
    return tag.innerText;
  }
  return '';
};

const getChannelName = ({ channel = null, companyName = '' }) => {
  let chatName = '';

  if (channel) {
    if (channel.type === ChannelsService.TYPE_SUPPORT) chatName = companyName;
    else chatName = channel.channelName;
  }

  return chatName || channel.name;
};

const getChannelIcon = ({ item, token, logo }) => {
  if (item && item.type === ChannelsService.TYPE_SUPPORT) return ProfileService.getLogo(logo, token);
  return UserService.getAvatar({ ...item, token });
};

const getChannelStatus = (channel) => {
  if (channel) {
    if (channel.type === ChannelsService.TYPE_SUPPORT) return null;
    return channel.is_online;
  }
  return null;
};


const enhance = compose(
  connect(mapStateToProps, null),
  translate('portal'),
  withProps((props) => {
    const lastMessage = html2text(props.item.content);
    const src = getChannelIcon(props);
    const chatName = getChannelName({ channel: props.item, companyName: props.companyName });
    const chatStatus = getChannelStatus(props.item);
    return { ...props, src, lastMessage, chatName, is_online: chatStatus };
  }),
);

export default hoistStatics(enhance)(User);



// WEBPACK FOOTER //
// ./src/views/modules/messages/startConversation/user/index.js